import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpApi from 'i18next-http-backend'
import { getTenantFromUrl } from './services/api.service'

// Get default language based on tenant
const getDefaultLanguage = () => {
  const tenant = getTenantFromUrl()
  switch (tenant) {
    case 'OCP_FR':
      return 'fr'
    case 'OCP_PT':
    default:
      return 'pt'
  }
}

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: getDefaultLanguage(),
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      caches: ['localStorage'],
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    react: {
      useSuspense: false, // CoreUI may have issues with Suspense
    },
  })

export default i18n
